import "./style/style.css";

export function QRCode() {
  return (
    <section className="qr-code-container">
      <h5 style={{ color: "#25cb54" }}>
        Experience the next big thing in crash games.
      </h5>
      <h1>Scan to Play EverMines Now!</h1>
      <br />
      <br />
      <br />
      <img src="img/qr-code-prod.png" alt="" className="qr-image" />
      <br />
      <a
        target="_blank"
        rel="noopener noreferrer"
        style={{ color: "#1ecb56" }}
        href="https://play.evermines.com/qr"
      >
        Click to play demo !
      </a>
    </section>
  );
}
